import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EmployeeTemplateResponse } from '../../../types/EmployeeTemplate';

type UseGetAllEmployeeTemplatesParams = {
  page?: number;
  per_page?: number;
  search?: string;
  filters?: {
    archived?: boolean;
  };
};

export type UseGetAllEmployeeTemplatesProps = {
  params?: UseGetAllEmployeeTemplatesParams;
  enabled?: boolean;
};

export const fetchAllEmployeeTemplates = async ({ params }: UseGetAllEmployeeTemplatesProps) => {
  const response = await CustomAxios.get<EmployeeTemplateResponse>('employee_templates', { params });
  return response.data;
};

export function useGetAllEmployeeTemplates({ params, enabled = true }: UseGetAllEmployeeTemplatesProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.allEmployeeTemplates, params],
    queryFn: () => fetchAllEmployeeTemplates({ params }),
    placeholderData: keepPreviousData,
  });
}
